import type { Router } from 'vue-router'
import { sendPlatformPageView } from '@/api/pageViews'
import type { PlatformPage } from '@/types/analytics'

const PATH_MAX_LENGTH = 255

/** Route name to platform page key. Only these routes are ever tracked. */
export const PLATFORM_PAGE_ROUTES: Readonly<Record<string, PlatformPage>> = {
  'home': 'home',
  'public.about': 'about',
  'public.for-organizers': 'for_organizers',
  'public.for-participants': 'for_participants',
  'public.docs.index': 'docs',
  'public.docs.category': 'docs',
  'public.docs.article': 'docs',
  'organizer.login': 'organizer_login',
  'participant.login': 'participant_login',
  'organizer.onboarding': 'organizer_onboarding',
}

function normalisePath(path: string): string {
  const lower = path.toLowerCase()
  const trimmed = lower.length > 1 ? lower.replace(/\/+$/, '') : lower
  return trimmed.slice(0, PATH_MAX_LENGTH)
}

/**
 * Send a cookieless platform page view after every successful navigation to a whitelisted
 * route. Fire-and-forget; logged-in and anonymous visitors are treated identically.
 */
export function trackPlatformPageViews(router: Router): void {
  router.afterEach((to, from, failure) => {
    try {
      if (failure) {
        return
      }
      if (from.matched.length > 0 && to.path === from.path) {
        return
      }
      const page = PLATFORM_PAGE_ROUTES[String(to.name)]
      if (page === undefined) {
        return
      }
      sendPlatformPageView(page, page === 'docs' ? normalisePath(to.path) : null, to.query)
    } catch {
      // Analytics must never affect navigation.
    }
  })
}
